// ============================================================
// FILE: resources/js/plugins/navbar.js
// USPATIH GO — Navbar Scroll Effect
// ============================================================

import { debounce } from '../helpers/utils.js';

document.addEventListener('DOMContentLoaded', () => {
  const navbar = document.getElementById('main-navbar');
  if (!navbar) return;

  window.addEventListener('scroll', debounce(() => {
    navbar.classList.toggle('scrolled', window.scrollY > 20);
  }, 50));
});
